import React from 'react';
import { Link } from 'react-router-dom';
import './ProjectsDropdown.css';

const categories = [
  'Research',
  'Quant Club',
  'Other'
];

function ProjectsDropdown() {
  return (
    <div className="dropdown" role="menu" aria-label="Projects navigation">
      <div className="dropdown-col">
        <h4 className="dropdown-heading">
          Quick Access
        </h4>
        <Link to="/projects?sort=new&limit=3" className="dropdown-link" role="menuitem">
          <span className="link-content">
            <span className="link-title">Latest Projects</span>
            <span className="link-description">See our newest work</span>
          </span>
        </Link>
        <Link to="/projects?sort=popular&limit=3" className="dropdown-link" role="menuitem">
          <span className="link-content">
            <span className="link-title">Most Popular</span>
            <span className="link-description">Top-rated projects</span>
          </span>
        </Link>
      </div>
      
      <div className="dropdown-col">
        <h4 className="dropdown-heading">
          Categories
        </h4>
        {categories.map(cat => (
          <Link
            key={cat}
            to={`/projects?category=${encodeURIComponent(cat)}`}
            className="dropdown-link category-link"
            role="menuitem"
          >
            <span className="link-content">
              <span className="link-title">{cat}</span>
            </span>
          </Link>
        ))}
      </div>
      
      <div className="dropdown-col">
        <h4 className="dropdown-heading">
          Explore More
        </h4>
        <Link to="/projects" className="dropdown-link" role="menuitem">
          <span className="link-content">
            <span className="link-title">All Projects</span>
            <span className="link-description">Browse everything</span>
          </span>
        </Link>
        <Link to="/projects/archive" className="dropdown-link" role="menuitem">
          <span className="link-content">
            <span className="link-title">Archive</span>
            <span className="link-description">Past projects</span>
          </span>
        </Link>
      </div>
    </div>
  );
}

export default ProjectsDropdown;
